import { CountryCode } from "libphonenumber-js";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import { PropertyConfig } from "../../../forms/propertyConfig";
import { PhoneLocale } from "../../../models/locale.model";
import { anyReallyAny } from "../../../tools/object.tools";
import { RegisterValidator, Validator } from "./validator";

// More informations about the library here : https://gitlab.com/catamphetamine/libphonenumber-js
// Possibility to reduce the size of the bundle by building metadata

/**
 * This validator ensures the value is a plausible phone number, using the parsing library libphonenumber-js.
 * The phone number can present separator character like -, /, ., whitespace, brackets or tildes.
 * sample use in propertyConfig => validators: validatorEntry(PhoneNumberValidator, "FR") or validators: { phoneNumber: "FR" } (second option requires this class to be loaded)
 */
@RegisterValidator("phoneNumber")
export class PhoneNumberValidator implements Validator<string, PhoneLocale> {

    /**
     * @returns true if propertyValue is >= minValue
     */
    public isValid(property: PropertyConfig, propertyValue: string, validatorParameters: string, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        if (propertyValue == null || propertyValue as anyReallyAny === "") {
            // If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
            return true;
        }
        // Can throw error when args are not correct. Should encapsulate in try/catch block ?
        const tmp = parsePhoneNumberFromString(propertyValue, { defaultCountry: validatorParameters as CountryCode, extract: false });
        if (tmp) {
            // Parsing went fine, now we need to validate input
            return tmp.isValid();
        } else {
            // Couldn't parse something that looks like a phoneNumber
            return false;
        }
    }
}